import {Mapper} from '@s-ui/domain'

export class FromRawParamToCreateLastCallRequestValueObjectMapper extends Mapper {
  constructor({config, createLastCallRequestValueObjectFactory}) {
    super()
    this._config = config
    this._createLastCallRequestValueObjectFactory = createLastCallRequestValueObjectFactory
  }

  map = ({adId, dealerId, makeId, postalCode, title, uniqueVehicleId, userId} = {}) => {
    return this._createLastCallRequestValueObjectFactory({
      adId,
      dealerId,
      makeId,
      postalCode,
      title,
      uniqueVehicleId,
      userId
    })
  }
}
